import React from "react";

function BackArrowIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="18"
            height="18"
            fill="none"
            viewBox="0 0 18 18"
        >
            <path
                stroke="var(--color-highlight)"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M17 9.014L1 8.995M9 17L1 9l8-8"
            ></path>
        </svg>
    );
}

export default BackArrowIcon;
